import api from '@/api'
import format from '@/utils/format'
import status from '@/utils/status'
import options from '@/utils/options'

const state = {
	params: {
		keyword: '',
		page: 1,
		count: 30,
		filter: {}
	},
	list: [],
	count: 1,
	headers: [],
	filterList: {
		isApprove: {
			title: '승인 상태',
			options: []
		},
		analysisDept: {
			title: '시험부서',
			options: [],
			type: 'radio'
		},
		testId: {
			title: '시험 항목',
			options: []
		},
		createDatetime: {
			title: '의뢰일',
			value: '',
			type: 'date'
		},
		endDatetime: {
			title: '발급 예정일',
			value: '',
			type: 'date'
		}
	},
	chartsets: {
		labels: [''],
		datasets: [
			{
				label: '진행중',
				data: [3],
				backgroundColor: '#FF922D'
			},
			{
				label: '분석완료',
				data: [10],
				backgroundColor: '#6C60CD'
			}
		]
	},
	filterCategoryList: [],
	isFilterInitialized: false
}

const getters = {
	headers: (state) => {
		return state.headers.map((header) => {
			return {
				key: header.headerKey,
				label: header.text,
				isSort: header.isSort,
				sort: header.sort,
				link: header.link,
				formatter: (value, key, item) => {
					if (!value) return '-'

					if (key.indexOf('Date') >= 0) {
						value = format.date({ date: value, onlyDate: true })
					} else if (key === 'isApprove') {
						value = status.approval.filter(
							(el) => el.value === value
						)[0]
					} else if (key == 'status') {
						value = {
							text: status.text[value],
							color: status.color[value]
						}
					}
					return value
				}
			}
		})
	},
	list: (state) => {
		return state.list.map((item) => {
			item.isNew =
				item.createDatetime >=
				format.date({ date: new Date(), onlyDate: true })
					? true
					: false
			return item
		})
	},
	count: (state) => state.count,
	params: (state) => state.params,
	filterList: (state) => {
		state.filterList.analysisDept.options = [...options.anaDeptOptions]
		state.filterList.testId.options = state.filterCategoryList.map((el) => {
			el.text = el.name
			el.value = el.id
			return el
		})
		return state.filterList
	},
	chartsets: (state) => state.chartsets,
	filterCategoryList: (state) => state.filterCategoryList,
	isFilterInitialized: (state) => state.isFilterInitialized,
	listRequestParams: (state) =>
		normalizeListParams(state.params, state.filterCategoryList)
}

/** 전체 시험 항목이 선택된 경우 testId 필터는 생략(쿼리·URL 부하 감소) — 단, analysisDept로 분야가 한정된 경우에만 */
function normalizeListParams(params, filterCategoryList) {
	const allIds = (filterCategoryList || []).map((el) => el.id)
	if (!params?.filter?.testId || allIds.length === 0) return params

	const deptScope = params.filter?.analysisDept
	const hasDeptScope =
		Array.isArray(deptScope) && deptScope.length > 0
	if (!hasDeptScope) return params

	const selected = Array.isArray(params.filter.testId)
		? params.filter.testId
		: [params.filter.testId]
	const allSet = new Set(allIds)
	const validSelected = selected.filter((id) => allSet.has(id))

	if (
		validSelected.length >= allIds.length &&
		allIds.every((id) => validSelected.includes(id))
	) {
		const { testId, ...restFilter } = params.filter
		return { ...params, filter: restFilter }
	}

	return params
}

const mutations = {
	setList: (state, data) => {
		if (!data?.table) {
			state.list = []
			state.count = 0
			return
		}

		state.list = [...(data.table.list || [])]
		state.count = data.table.count ?? 0
		if (Array.isArray(data.table.header) && data.table.header.length > 0) {
			state.headers = [...data.table.header]
		}
		if (data.summary) {
			state.chartsets = { ...state.chartsets }
			state.chartsets.datasets[0].data = [data.summary.WAIT ?? 0]
			state.chartsets.datasets[1].data = [data.summary.COMPLETE ?? 0]
		}
	},
	setParams: (state, data) => {
		if (data.filter !== undefined) {
			state.params = {
				...state.params,
				...data,
				filter: { ...state.params.filter, ...data.filter }
			}
		} else {
			state.params = { ...state.params, ...data }
		}
	},
	resetParams: (state) => {
		state.params = {
			keyword: '',
			page: 1,
			count: 30,
			filter: {}
		}
	},
	setFilterList: (state, data) => {
		state.filterList = { ...state.filterList }
		state.filterList.isApprove.options = [...status.approval]
	},
	setFilterCategoryList: (state, data) => {
		state.filterCategoryList = [...data]
	},
	setFilterInitialized: (state) => {
		state.isFilterInitialized = true
	}
}

// async 됨
const actions = {
	loadAnalysisList: async ({ commit, state }, params) => {
		const requestParams = normalizeListParams(
			params ? params : state.params,
			state.filterCategoryList
		)
		const res = await api.analysis.getList(requestParams)
		if (!res?.table) {
			commit('setList', {
				table: { list: [], count: 0 },
				summary: { WAIT: 0, COMPLETE: 0 }
			})
			return false
		}
		commit('setList', res)
		commit('setFilterList')
		return true
	},
	loadFilterCategoryList: async ({ commit }, types) => {
		const res = await api.analysis.getFilterCategoryList(types)
		commit('setFilterCategoryList', Array.isArray(res) ? res : [])
	}
}

export default { namespaced: true, state, getters, mutations, actions }
